import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Slide,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import AccountingEntries from './AccountingEntries'; // Assuming this is the correct path
import Notification from './Notification';
import DraggableDialogPaper from './DraggableDialogPaper';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3),
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  cursor: 'move',
}));

const AccountingEntriesModal = ({ open, onClose, invoiceId, invoiceNumber, erpListsStore }) => {
  const [finalizeError, setFinalizeError] = React.useState('');
  const isCompactViewport = useMediaQuery('(max-width:1100px), (max-height:900px)');

  if (!invoiceId) return null;

  const handleFinalize = (errorMsg) => {
    if (errorMsg) {
      setFinalizeError(errorMsg);
    } else {
      setFinalizeError('');
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isCompactViewport}
      maxWidth={false}
      PaperComponent={isCompactViewport ? undefined : DraggableDialogPaper}
      PaperProps={{
        sx: {
          width: isCompactViewport ? '100%' : '98vw',
          maxWidth: isCompactViewport ? '100%' : '98vw',
          height: isCompactViewport ? '100%' : '95vh',
          maxHeight: isCompactViewport ? '100%' : '95vh',
          margin: isCompactViewport ? 0 : '8px',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        },
      }}
      TransitionComponent={Transition}
    >
      <StyledDialogTitle
        className={isCompactViewport ? '' : 'draggable-dialog-title'}
        sx={{ cursor: isCompactViewport ? 'default' : 'move', px: { xs: 1.5, sm: 3 }, py: { xs: 1, sm: 2 } }}
      >
        <Typography variant="h6" component="div" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
          Causación Contable: {invoiceNumber || 'N/A'}
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      {/* Notificación de error de validación */}
      {finalizeError && (
        <Notification
          message={finalizeError}
          onClose={() => setFinalizeError('')}
        />
      )}
      <DialogContent sx={{ p: { xs: 0.5, sm: 1 }, flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <AccountingEntries 
          invoiceId={invoiceId}
          showFinalizeButton
          onFinalize={handleFinalize}
          finalizeError={finalizeError}
          erpListsStore={erpListsStore}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AccountingEntriesModal;
